import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Importa useNavigate
import { useMaterialUIController } from "context"; // Importa el controlador de contexto de Material UI
import axios from "axios";
import API_ENDPOINTS from "config/api";
import MDAvatar from "components/MDAvatar";
import Divider from "@mui/material/Divider";
// Images
import logoAtlassian from "assets/images/small-logos/logo-atlassian.svg";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";
import { Icon, IconButton, Menu, MenuItem } from "@mui/material"; // Import Menu and MenuItem
import Modal from "@mui/material/Modal";

function Empresas() {
  const navigate = useNavigate(); // Hook para navegación
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null); // State to hold the anchor element for the menu
  const [selectedEmpresaId, setSelectedEmpresaId] = useState(null);
  const [controller, dispatch] = useMaterialUIController(); // Obtén el controlador y dispatch
  const { sidenavColor } = controller; // Obtén el color del sidenav desde el controlador

  const handleOpen = () => setOpenRegistrar(true); // Para el modal de registrar empresa
  const handleClose = () => setOpenRegistrar(false);

  const [openRegistrar, setOpenRegistrar] = useState(false);
  const handleOpenMenu = (event, id) => {
    setMenuAnchor(event.currentTarget); // Store the anchor element
    setSelectedEmpresaId(id);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
    setSelectedEmpresaId(null);
  };

  const handleIngresar = () => {
    if (selectedEmpresaId) {
      import("context").then((contextModule) => {
        contextModule.setSelectedCompany(dispatch, selectedEmpresaId);
      });
      navigate(`/dashboard/${selectedEmpresaId}`);
    }
    handleCloseMenu();
  };

  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.EMPRESAS);
        const empresasData = response.data;

        // Transform the data into the format expected by DataTable
        const rows = empresasData.map((empresa) => ({
          nombre: (
            <MDBox display="flex" alignItems="center" lineHeight={1}>
              <MDAvatar src={logoAtlassian} name={empresa.nombre} size="sm" variant="rounded" />
              <MDTypography
                display="block"
                variant="button"
                fontWeight="medium"
                ml={1}
                lineHeight={1}
              >
                {empresa.nombre}
              </MDTypography>
            </MDBox>
          ),
          estatus: (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={empresa.estado ? "online" : "offline"}
                color={empresa.estado ? "success" : "dark"}
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ),
          direccion: empresa.direccion,
          telefono: empresa.telefono,
          email: empresa.email,
          acción: (
            <IconButton onClick={(event) => handleOpenMenu(event, empresa.id)}>
              <Icon>more_vert</Icon>
            </IconButton>
          ),
        }));

        const columns = [
          { Header: "Nombre", accessor: "nombre", width: "25%" },
          { Header: "Dirección", accessor: "direccion", width: "25%" },
          { Header: "Estatus", accessor: "estatus", width: "10%" },
          { Header: "Teléfono", accessor: "telefono", width: "10%" },
          { Header: "Email", accessor: "email", width: "20%" },
          { Header: "Acción", accessor: "acción", width: "10%" },
        ];

        setEmpresas({ columns: columns, rows: rows });
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    };

    fetchEmpresas();
  }, []);

  const registrarBD = async (e) => {
    try {
      e.preventDefault();
      const form = document.getElementById("registerForm");
      const formData = new FormData(form);

      // Construir el RIF combinando la letra y el número
      const rifLetra = formData.get("rif-l");
      const rifNumero = formData.get("rif");
      const RIF = rifLetra && rifNumero ? `${rifLetra}-${rifNumero}` : "";

      // Obtener el nombre corto del campo readonly
      const nomcorto = document.getElementById("nombreCorto").value;

      const emp = {
        nombre: formData.get("nombre") || "",
        RIF: RIF,
        nomcorto: nomcorto || "",
        direccion: formData.get("direccion") || "",
        telefono: formData.get("telefono") || "",
        email: formData.get("email") || "",
        estado: formData.get("estado") || "activo",
        descripcion: formData.get("descripcion") || "",
      };

      console.log("Datos a enviar:", emp);

      const response = await axios.post(API_ENDPOINTS.EMPRESAS, emp);
      console.log("Respuesta del servidor:", response);
      alert("Empresa registrada exitosamente.");
      handleClose();
      // Recargar la lista de empresas
      window.location.reload();
    } catch (error) {
      console.error("Error completo:", error);
      if (error.response && error.response.data) {
        console.error("Errores de validación:", error.response.data);
        const errores = error.response.data.errors || error.response.data.message;
        alert(`Error al registrar Empresa:\n${JSON.stringify(errores, null, 2)}`);
      } else {
        alert("Error al registrar Empresa.");
      }
    }
  };

  const registrar = (
    <Modal open={openRegistrar} onClose={handleClose}>
      <form
        id="registerForm"
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "20px",
          backgroundColor: "rgb(240, 240, 240)",
          borderRadius: "8px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1000,
          width: "40rem",
        }}
        onSubmit={registrarBD}
      >
        <MDBox
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 16px",
            marginTop: "-24px",
            padding: "24px 16px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
          bgColor={sidenavColor}
        >
          <MDTypography variant="h6" color="white" fontWeight="medium">
            <em>Registrar Empresa</em>
          </MDTypography>
        </MDBox>
        <MDBox
          style={{ display: "flex", flexDirection: "row", marginBottom: "10px", gap: "10px" }}
          my={2}
          justifyContent="center"
        >
          <input
            type="text"
            name="nombre"
            placeholder="Nombre"
            required
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
            onChange={(e) => {
              const value = e.target.value;
              const abbreviation = value
                .split(" ")
                .map((word) => word.slice(0, 2).toUpperCase())
                .join("");
              document.getElementById("nombreCorto").value = abbreviation || "Nombre corto";
            }}
          />
          <input
            type="text"
            id="nombreCorto"
            placeholder="Nombre corto"
            readOnly
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px #ccc",
              fontStyle: "italic",
              borderStyle: "none",
              backgroundColor: "#f5f5f5",
            }}
          />
        </MDBox>
        <MDBox style={{ display: "flex", flexDirection: "column", marginBottom: "10px" }}>
          <textarea
            name="descripcion"
            placeholder="Descripción"
            rows="2"
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
              resize: "none",
            }}
          />
        </MDBox>
        <MDBox
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: "10px",
            justifyContent: "center",
          }}
        >
          <input
            type="email"
            name="email"
            placeholder="Email"
            required
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
              marginRight: "1rem",
            }}
          />
          <select
            name="rif-l"
            required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          >
            <option value="" disabled selected>
              RIF
            </option>
            <option value="C">C -</option>
            <option value="E">E -</option>
            <option value="G">G -</option>
            <option value="J">J -</option>
            <option value="P">P -</option>
            <option value="V">V -</option>
          </select>
          <input
            type="number"
            name="rif"
            placeholder="Nro"
            required
            style={{ padding: "10px", fontSize: "14px" }}
          />
        </MDBox>
        <MDBox style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}>
          <label style={{ fontWeight: "bold", marginRight: "1rem" }}>Responsable:</label>
          <select
            name="responsable"
            //required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          >
            <option value="" disabled selected>
              Seleccione una opción
            </option>
          </select>
          {/* Aquí se debe hacer una consulta a la base de datos para obtener los responsables */}
          <input
            type="phone"
            name="telefono"
            required
            placeholder="Teléfono"
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              marginLeft: "2rem",
            }}
          />
        </MDBox>
        <MDBox style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}>
          <input
            type="text"
            name="direccion"
            placeholder="Dirección"
            required
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          />
        </MDBox>
        <MDBox
          style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}
          justifyContent="center"
        >
          <input
            type="text"
            name="Contacto"
            placeholder="Contacto"
            required
            style={{
              marginRight: "3rem",
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          />
          <label style={{ fontWeight: "bold", marginBottom: "5px", marginRight: "0.5rem" }}>
            Estatus:
          </label>
          <select
            name="estado"
            required
            style={{
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              borderStyle: "none",
            }}
          >
            <option value="activo">
              <em>Activo</em>
            </option>
            <option value="inactivo">
              <em>Inactivo</em>
            </option>
          </select>
        </MDBox>
        <label style={{ fontWeight: "bold" }}> Documentos: </label>
        <MDBox style={{ display: "flex", flexDirection: "row", marginBottom: "10px" }}>
          <input
            type="file"
            name="Documentos"
            placeholder="Documentos"
            style={{
              flex: 1,
              padding: "10px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontStyle: "italic",
              borderStyle: "none",
            }}
          />
        </MDBox>
        <MDBox style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <MDButton
            type="button"
            id="cancelButton"
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#6c757d",
              color: "#fff",
              cursor: "pointer",
            }}
            onClick={handleClose}
          >
            Cancelar
          </MDButton>
          <MDButton
            type="submit"
            color={sidenavColor}
            style={{
              padding: "10px",
              borderRadius: "4px",
              border: "none",
              cursor: "pointer",
            }}
          >
            Registrar
          </MDButton>
        </MDBox>
      </form>
    </Modal>
  );

  const renderMenu = () => (
    <Menu
      anchorEl={menuAnchor}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(menuAnchor)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <MenuItem onClick={handleIngresar}>
        <MDTypography variant="body2" color="dark">
          Ingresar
        </MDTypography>
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleCloseMenu}>
        <MDTypography variant="body2" color="dark">
          Editar
        </MDTypography>
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleCloseMenu}>
        <MDTypography variant="body2" color="dark">
          Eliminar
        </MDTypography>
      </MenuItem>
    </Menu>
  );

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Lista de Empresas
                  </MDTypography>
                </MDBox>
                <MDBox pt={3}>
                  <MDTypography variant="body2" color="text" fontWeight="medium">
                    Cargando lista de empresas...
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor={sidenavColor}
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Lista de Empresas
                  </MDTypography>
                </MDBox>
                <MDBox pt={3}>
                  <MDTypography variant="body2" color="error" fontWeight="medium">
                    Error al cargar la lista de empresas: {error.message}
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor={sidenavColor}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Lista de Empresas
                </MDTypography>
              </MDBox>
              <MDBox padding={3}>
                <MDBox display="flex">
                  <MDButton variant="gradient" color={sidenavColor} onClick={handleOpen}>
                    Registrar Empresa
                  </MDButton>
                  <MDBox component="form" display="flex" justifyContent="flex-end" flexGrow={1}>
                    <input
                      type="text"
                      placeholder="Buscar"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{
                        padding: "8px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        marginRight: "8px",
                      }}
                    />
                  </MDBox>
                </MDBox>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={empresas}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
                {renderMenu()}
                {registrar}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Empresas;
